import { render, staticRenderFns } from "./QuickstartForm2.vue?vue&type=template&id=2ee02857&scoped=true&"
import script from "./QuickstartForm2.vue?vue&type=script&lang=js&"
export * from "./QuickstartForm2.vue?vue&type=script&lang=js&"
import style0 from "./QuickstartForm2.vue?vue&type=style&index=0&id=2ee02857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee02857",
  null
  
)

export default component.exports